module.exports = __webpack_public_path__ + "img/radio-tower.899d949.svg";